import React from "react";
import {
  PrimaryButton,
  SecondaryButton,
  formatShortDate,
  formatSquadInfo,
} from "../../../UI/DesignStandards";
import {
  bowlerNames,
  moneyLabel,
  placementLabel,
  signupMoney,
  waitlistPositionLabel,
} from "../../../../utility/signupDashboard";

const SignupCard = ({
  signup,
  signups,
  actionLoading,
  onViewSignup,
  onViewAverageProof,
  onMarkPaid,
  onMarkUnpaid,
}) => {
  const placement = placementLabel(signup);
  const money = moneyLabel(signup);
  const moneyState = signupMoney(signup);
  const waitlist = waitlistPositionLabel(signup, signups);
  const squad = signup.squads;
  const busy = actionLoading;

  return (
    <div className="border border-brand-charcoal/10 rounded-lg p-6 hover:bg-brand-cream/50 transition-all duration-200">
      <div className="flex items-center justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2 mb-1">
            <h3 className="font-semibold text-brand-charcoal truncate">
              {bowlerNames(signup)}
            </h3>
            <span className="px-2 py-1 text-xs font-medium rounded-lg bg-brand-cream text-brand-charcoal">
              {waitlist || placement}
            </span>
            {money ? (
              <span className="px-2 py-1 text-xs font-medium rounded-lg bg-brand-charcoal text-brand-cream">
                {money}
              </span>
            ) : null}
            {signup.disputed ? (
              <span className="px-2 py-1 text-xs font-medium rounded-lg bg-red-800 text-white">
                Disputed
              </span>
            ) : null}
            {signup.refundRequested ? (
              <span className="px-2 py-1 text-xs font-medium rounded-lg bg-brand-gold text-brand-charcoal">
                Refund requested
              </span>
            ) : null}
          </div>
          <p className="text-sm text-brand-muted mb-1">
            <span className="font-medium text-brand-charcoal">
              {signup.tournamentEvents?.eventName}
            </span>
            {squad
              ? ` · ${formatSquadInfo(squad.squadDate, squad.squadTime)}`
              : ""}
          </p>
          <p className="text-sm text-brand-muted">
            {signup.email}
            {signup.createdAt
              ? ` · ${formatShortDate(signup.createdAt)}`
              : ""}
          </p>
          {signup.heldUntil &&
          (signup.status === "held" || signup.paymentStatus === "held") ? (
            <p className="text-sm text-brand-muted mt-1">
              Hold ends {new Date(signup.heldUntil).toLocaleString()}
            </p>
          ) : null}
        </div>
        <div className="flex flex-col sm:flex-row gap-2 shrink-0">
          {moneyState === "due" || moneyState === "held" ? (
            <PrimaryButton
              onClick={() => onMarkPaid(signup)}
              disabled={busy}
              loading={busy}
              className="!px-3 !py-2 text-sm"
            >
              Mark paid
            </PrimaryButton>
          ) : null}
          {moneyState === "walk_up" ? (
            <SecondaryButton
              onClick={() => onMarkUnpaid(signup)}
              disabled={busy}
              className="!px-3 !py-2 text-sm"
            >
              Mark unpaid
            </SecondaryButton>
          ) : null}
          {signup.averageProofPath ? (
            <SecondaryButton
              onClick={() => onViewAverageProof(signup)}
              disabled={busy}
              className="!px-3 !py-2 text-sm"
            >
              Average verification
            </SecondaryButton>
          ) : null}
          <SecondaryButton
            onClick={() => onViewSignup(signup)}
            disabled={busy}
            className="!px-3 !py-2 text-sm"
          >
            View
          </SecondaryButton>
        </div>
      </div>
    </div>
  );
};

export default SignupCard;
